import { getSupabase } from "../supabase";

/**
 * MER-213: data layer for the /admin Overview landing page.
 *
 * Customer counts and per-customer health reuse listCustomers()
 * (lib/admin/customers) and fetchEntityHealth() (lib/admin/health);
 * the only new read here is the impersonation audit feed.
 *
 * Recent logins are deliberately absent: they need the
 * dashboard_event table from MER-208, which is not built. Per the
 * no-empty-frame rule the section is omitted entirely rather than
 * rendered hollow; see the MER-185 plan comment (2026-06-10).
 */

export interface ImpersonationEvent {
  id: string;
  staffUserId: string;
  targetTenantId: string;
  eventType: "start" | "stop";
  occurredAt: string;
}

interface ImpersonationEventRow {
  id: string;
  staff_user_id: string;
  target_tenant_id: string;
  event_type: "start" | "stop";
  occurred_at: string;
}

/**
 * Last N impersonation audit rows, newest first. Staff-read RLS on
 * impersonation_event (migration 0016). staff_user_id stays a uuid in
 * v1: auth.users email is not client-readable without a SECURITY
 * DEFINER view, and at one staff user the column is decoration.
 */
export async function fetchRecentImpersonations(limit = 10): Promise<ImpersonationEvent[]> {
  const supabase = getSupabase();
  const { data, error } = await supabase
    .from("impersonation_event")
    .select("id, staff_user_id, target_tenant_id, event_type, occurred_at")
    .order("occurred_at", { ascending: false })
    .limit(limit);
  if (error) throw new Error(`fetchRecentImpersonations failed: ${error.message}`);
  const rows = (data as ImpersonationEventRow[] | null) ?? [];
  return rows.map((r) => ({
    id: r.id,
    staffUserId: r.staff_user_id,
    targetTenantId: r.target_tenant_id,
    eventType: r.event_type,
    occurredAt: r.occurred_at,
  }));
}
